import { Color } from './statics';

export const GoogleSigninButton = () => null;
GoogleSigninButton.Color = Color;
GoogleSigninButton.Size = {
  Icon: 0,
  Standard: 1,
  Wide: 2,
};
